import { createContext, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem("nutriscan_token");
    if (!token) { setLoading(false); return; }
    api.get("/auth/me")
      .then((res) => setUser(res.data))
      .catch(() => localStorage.removeItem("nutriscan_token"))
      .finally(() => setLoading(false));
  }, []);

  const authSuccess = (data) => {
    localStorage.setItem("nutriscan_token", data.access_token);
    setUser(data.user);
  };

  const login = async (email, password) => {
    const res = await api.post("/auth/login", { email, password });
    authSuccess(res.data);
    return res.data.user;
  };

  // Регистрация с кодом на email. Если код отключён супер-админом — аккаунт создаётся сразу.
  const requestRegisterCode = async (name, email, password) => {
    const res = await api.post("/auth/register/request-code", { name, email, password });
    if (res.data.access_token) { authSuccess(res.data); return { user: res.data.user }; }
    return { code_sent: true, email: res.data.email };
  };

  const verifyRegisterCode = async (email, code) => {
    const res = await api.post("/auth/register/verify", { email, code });
    authSuccess(res.data);
    return res.data.user;
  };

  const requestResetCode = async (email) => {
    const res = await api.post("/auth/reset/request-code", { email });
    return { code_sent: true, email: res.data.email };
  };

  const verifyReset = async (email, code, password) => {
    const res = await api.post("/auth/reset/verify", { email, code, password });
    authSuccess(res.data);
    return res.data.user;
  };

  const logout = () => {
    localStorage.removeItem("nutriscan_token");
    setUser(null);
  };

  const setUserPrefs = (preferences) => setUser((u) => (u ? { ...u, preferences } : u));

  return (
    <AuthContext.Provider value={{ user, loading, login, requestRegisterCode, verifyRegisterCode, requestResetCode, verifyReset, logout, setUserPrefs }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
